<div class="new-result-banner">
    <div class="container">
      <div class="row">
        <div class="img">
          <img routerLink="/results" style="border-radius: 28px;" class="img-fluid d-block d-sm-none"
                              src="https://media.iquanta.in/ui_images/home-image/results-2024-mob.webp"
                              alt="CAT Coaching">
          <img routerLink="/results" style="border-radius: 28px;" class="img-fluid d-none d-sm-block" src="https://media.iquanta.in/ui_images/home-image/results-2024.webp" alt="CAT 2024 Toppers">
        </div>
      </div>
    </div>
  </div>

  <div class="gif_img_section">
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <div class="video-card-in mobile-none">
                    <iframe src="https://www.youtube.com/embed/0job0Ca6J5I?autoplay=1&mute=1&loop=1&modestbranding=1&rel=0&fs=0&playlist=0job0Ca6J5I"
                        width="475" height="267" frameborder="0" webkitallowfullscreen mozallowfullscreen
                        allowfullscreen allowfullscreen="true" allow="autoplay" data-ready="true"></iframe>
                </div>
                <div class="video-card-in desk-none">
                    <iframe src="https://www.youtube.com/embed/0job0Ca6J5I?autoplay=1&mute=1&loop=1&modestbranding=1&rel=0&fs=0&playlist=0job0Ca6J5I"
                        width="330" height="194" frameborder="0" webkitallowfullscreen mozallowfullscreen
                        allowfullscreen allowfullscreen="true" allow="autoplay" data-ready="true"></iframe>
                </div>
            </div>
            <div class="col-md-6">
                <div class="gif_img">
                    <img src="https://media.iquanta.in/ui_images/new-home/horizontal-bar.gif"
                    alt="700+ 99%ilers & 1200s of CAT Toppers">
                </div>
            </div>
        </div>
    </div>
  </div>

<div class="results_page">
    <div class="container">
        <div class="row">
            <div class="col-md-4 mobile_none">
                <div class="results_heading middle">
                    <h2 [ngClass]="{'score_card' : pageName == 'score'}">1200+ 99%ilers <br>
                        & 1200s of <br>
                        CAT Toppers</h2>
  
                    <h3>40,000 IIM calls in just 5 years</h3>
                </div>
            </div>
            <div class="col-md-8">
                <div class="left-topper-images ">
                    <div class="logo-slider toper_img1">
                        <div>
                            <div class="toppers-image-card">
                                <img src="https://media.iquanta.in/ui_images/cat2019/rishi-small.webp"
                                    alt="Rishi" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2017/gaurav-small.webp"
                                    alt="gaurav" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2015/prateek-small.webp"
                                    alt="prateek" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2015/sabyasachi-small.webp"
                                    alt="sabyasachi" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2017/aabhas-small.webp"
                                    alt="aabhas" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2017/shikhar-small.webp"
                                    alt="shikhar" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2016/dhruv-small.webp"
                                    alt="dhruv" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2018/mihir-small.webp"
                                    alt="mihir" loading="lazy">
                            </div>
                        </div>
                        <div>
                            <div class="toppers-image-card">
                                <img src="https://media.iquanta.in/ui_images/cat2019/rishi-small.webp"
                                    alt="Rishi" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2017/gaurav-small.webp"
                                    alt="gaurav" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2015/prateek-small.webp"
                                    alt="prateek" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2015/sabyasachi-small.webp"
                                    alt="sabyasachi" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2017/aabhas-small.webp"
                                    alt="aabhas" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2017/shikhar-small.webp"
                                    alt="shikhar" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2016/dhruv-small.webp"
                                    alt="dhruv" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2018/mihir-small.webp"
                                    alt="mihir" loading="lazy">
                            </div>
                        </div>
                        <div>
                            <div class="toppers-image-card">
                                <img src="https://media.iquanta.in/ui_images/cat2019/rishi-small.webp"
                                alt="Rishi" loading="lazy">
                            <img src="https://media.iquanta.in/ui_images/cat2017/gaurav-small.webp"
                                alt="gaurav" loading="lazy">
                            <img src="https://media.iquanta.in/ui_images/cat2015/prateek-small.webp"
                                alt="prateek" loading="lazy">
                            <img src="https://media.iquanta.in/ui_images/cat2015/sabyasachi-small.webp"
                                alt="sabyasachi" loading="lazy">
                            <img src="https://media.iquanta.in/ui_images/cat2017/aabhas-small.webp"
                                alt="aabhas" loading="lazy">
                            <img src="https://media.iquanta.in/ui_images/cat2017/shikhar-small.webp"
                                alt="shikhar" loading="lazy">
                            <img src="https://media.iquanta.in/ui_images/cat2016/dhruv-small.webp"
                                alt="dhruv" loading="lazy">
                            <img src="https://media.iquanta.in/ui_images/cat2018/mihir-small.webp"
                                alt="mihir" loading="lazy">
                            </div>
                        </div>
                    </div>
                    <div class="logo-slider logo-slider2 toper_img1">
                        <div>
                            <div class="toppers-image-card">
                                <img src="https://media.iquanta.in/ui_images/kislay-small.webp"
                                    alt="kislay" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/Shivam-Kumar-small.webp"
                                    alt="Shivam-Kumar" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/rahul-small.webp"
                                    alt="rahul" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/Ankit-Raj-small.webp"
                                    alt="Ankit-Raj" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/pratik-small.webp"
                                    alt="pratik" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/Ruhi-Singh-small.webp"
                                    alt="Ruhi-Singh" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/Rahul-Agrawal-thumb-small.webp"
                                    alt="Rahul-Agrawal" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/ananta-med.webp"
                                    alt="ananta" loading="lazy">
                            </div>
                        </div>
                        <div>
                            <div class="toppers-image-card">
                                <img src="https://media.iquanta.in/ui_images/kislay-small.webp"
                                    alt="kislay" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/Shivam-Kumar-small.webp"
                                    alt="Shivam-Kumar" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/rahul-small.webp"
                                    alt="rahul" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/Ankit-Raj-small.webp"
                                    alt="Ankit-Raj" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/pratik-small.webp"
                                    alt="pratik" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/Ruhi-Singh-small.webp"
                                    alt="Ruhi-Singh" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/Rahul-Agrawal-thumb-small.webp"
                                    alt="Rahul-Agrawal" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/ananta-med.webp"
                                    alt="ananta" loading="lazy">
                            </div>
                        </div>
                        <div>
                            <div class="toppers-image-card">
                                <img src="https://media.iquanta.in/ui_images/kislay-small.webp"
                                alt="kislay" loading="lazy">
                            <img src="https://media.iquanta.in/ui_images/Shivam-Kumar-small.webp"
                                alt="Shivam-Kumar" loading="lazy">
                            <img src="https://media.iquanta.in/ui_images/rahul-small.webp"
                                alt="rahul" loading="lazy">
                            <img src="https://media.iquanta.in/ui_images/Ankit-Raj-small.webp"
                                alt="Ankit-Raj" loading="lazy">
                            <img src="https://media.iquanta.in/ui_images/pratik-small.webp"
                                alt="pratik" loading="lazy">
                            <img src="https://media.iquanta.in/ui_images/Ruhi-Singh-small.webp"
                                alt="Ruhi-Singh" loading="lazy">
                            <img src="https://media.iquanta.in/ui_images/Rahul-Agrawal-thumb-small.webp"
                                alt="Rahul-Agrawal" loading="lazy">
                            <img src="https://media.iquanta.in/ui_images/ananta-med.webp"
                                alt="ananta" loading="lazy">
                            </div>
                        </div>
                    </div>
                    <div class="logo-slider logo-slider3 toper_img1">
                        <div>
                            <div class="toppers-image-card">
                                <img src="https://media.iquanta.in/ui_images/cat2020/Sabyasachi-Mishra-small.jpg"
                                    alt="Sabyasachi-Mishra" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2015/gursimran-small.jpg"
                                    alt="gursimran" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2017/siddharth-small.jpg"
                                    alt="siddharth" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2019/rishi-small.webp"
                                    alt="rishi" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2017/aabhas-small.webp"
                                    alt="aabhas" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2017/siddharth-small.jpg"
                                    alt="siddharth" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2017/siddharth-small.jpg"
                                    alt="siddharth" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2017/gaurav-small.webp"
                                    alt="gaurav" loading="lazy">
                            </div>
                        </div>
                        <div>
                            <div class="toppers-image-card">
                                <img src="https://media.iquanta.in/ui_images/cat2020/Sabyasachi-Mishra-small.jpg"
                                    alt="Sabyasachi-Mishra" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2015/gursimran-small.jpg"
                                    alt="gursimran" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2017/siddharth-small.jpg"
                                    alt="siddharth" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2019/rishi-small.webp"
                                    alt="rishi" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2017/aabhas-small.webp"
                                    alt="aabhas" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2017/siddharth-small.jpg"
                                    alt="siddharth" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2017/siddharth-small.jpg"
                                    alt="siddharth" loading="lazy">
                                <img src="https://media.iquanta.in/ui_images/cat2017/gaurav-small.webp"
                                    alt="gaurav" loading="lazy">
                            </div>
                        </div>
                        <div>
                            <div class="toppers-image-card">
                                <img src="https://media.iquanta.in/ui_images/cat2020/Sabyasachi-Mishra-small.jpg"
                                alt="Sabyasachi-Mishra" loading="lazy">
                            <img src="https://media.iquanta.in/ui_images/cat2015/gursimran-small.jpg"
                                alt="gursimran" loading="lazy">
                            <img src="https://media.iquanta.in/ui_images/cat2017/siddharth-small.jpg"
                                alt="siddharth" loading="lazy">
                            <img src="https://media.iquanta.in/ui_images/cat2019/rishi-small.webp"
                                alt="rishi" loading="lazy">
                            <img src="https://media.iquanta.in/ui_images/cat2017/aabhas-small.webp"
                                alt="aabhas" loading="lazy">
                            <img src="https://media.iquanta.in/ui_images/cat2017/siddharth-small.jpg"
                                alt="siddharth" loading="lazy">
                            <img src="https://media.iquanta.in/ui_images/cat2017/siddharth-small.jpg"
                                alt="siddharth" loading="lazy">
                            <img src="https://media.iquanta.in/ui_images/cat2017/gaurav-small.webp"
                                alt="gaurav" loading="lazy">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4 desktop_none">
                <div class="results_heading middle">
                    <h2 [ngClass]="{'score_card' : pageName == 'score'}">1200+ 99%ilers <br>
                        & 1200s of <br>
                        CAT Toppers</h2>

                    <h3>40,000 IIM calls in just 5 years</h3>
                </div>
            </div>
        </div>
    </div>
  </div>
  
  
